// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"dM_rmf","tooltip":"Dfpi03","fadeIn":"veqtwq","tooltipContent":"h3psic"};